module.exports = __webpack_public_path__ + "static/media/gym2.cd1db580.jpg";